import { render, staticRenderFns } from "./wtsLogin.vue?vue&type=template&id=f3bc2d38&scoped=true&"
import script from "./wtsLogin.vue?vue&type=script&lang=js&"
export * from "./wtsLogin.vue?vue&type=script&lang=js&"
import style0 from "./wtsLogin.vue?vue&type=style&index=0&id=f3bc2d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bc2d38",
  null
  
)

export default component.exports